import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input_container" }

import { ref, watch} from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'inputField',
  props: {
  modelValue: {
    type: [String, Number],
    default: ''
  },
  labelText: {
    type: String,
    default: ''
  }
},
  emits: ['update:modelValue', 'valueChanged'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const localValue = ref(props.modelValue)

watch(() => props.modelValue, (newVal) => {
  localValue.value = newVal
})

watch(localValue, (val) => {
  emit('update:modelValue', val)
  emit('valueChanged', val)
})

const onClear = () => {
  localValue.value = ''
  emit('update:modelValue', '')
  emit('valueChanged', '')
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_field, {
      modelValue: localValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
      type: "number",
      placeholder: __props.labelText,
      onClear: onClear,
      class: "custom-field"
    }, {
      "left-icon": _withCtx(() => _cache[1] || (_cache[1] = [])),
      "right-icon": _withCtx(() => [
        (localValue.value)
          ? (_openBlock(), _createBlock(_component_van_icon, {
              key: 0,
              name: "clear",
              class: "custom-clear",
              onClick: _withModifiers(onClear, ["stop"])
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "placeholder"])
  ]))
}
}

})